import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import PCUpcomingGame from '@/pages/intelligence/pages/Potential/UpcomingGames/PCGame';

export default function Upcoming() {
  const pageLogInfo = dbiPageLogMes.topChartsPCGamesUpcoming;
  const entityType = 'pc';
  return (
    <>
      <MarqueeBanner />
      <PCUpcomingGame entityType={entityType} pageLogInfo={pageLogInfo} />
    </>
  );
}
